import { queryKey } from '../constants/queryClientKey';
import {
  createTemplate,
  deleteTemplate,
  getTemplates,
  getTemplate,
  ParamsCreateTemplate,
  ParamsUpdateTemplate,
  updateTemplate,
} from '../apis/template.api';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

export function useGetTemplates(
  params: Parameters<typeof getTemplates>[0],
  options?: UseQueryOptions
) {
  return useQuery(
    [queryKey.template_report, sortObjectKeys(params)],
    () => getTemplates(params),
    {
      keepPreviousData: true,
      ...options,
    }
  ) as UseQueryResult<Awaited<ReturnType<typeof getTemplates>>>;
}

export function useGetTemplate(
  id: Parameters<typeof getTemplate>[0],
  options?: UseQueryOptions
) {
  return useQuery([queryKey.template_detail, id], () => getTemplate(id), {
    keepPreviousData: true,
    ...options,
  }) as UseQueryResult<Awaited<ReturnType<typeof getTemplate>>>;
}

export function useCreateTemplate() {
  const queryClient = useQueryClient();

  return useMutation(
    async (params: ParamsCreateTemplate) => createTemplate(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.template_report]);
      },
      onError: (err) => {
        console.error('useCreateTemplate:', err);
      },
    }
  );
}

export function useUpdateTemplate() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, data }: { id: string; data: ParamsUpdateTemplate }) =>
      updateTemplate(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.template_report]);
      },

      onError: (err) => {
        console.error('useUpdateTemplate:', err);
      },
    }
  );
}

export function useDeleteTemplate() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => deleteTemplate(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.template_report]);
    },
    onError: (err) => {
      console.error('useDeleteTemplate:', err);
    },
  });
}
